var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      staticClass: "mx-auto overflow-hidden",
      attrs: { "max-width": _vm.maxWidth },
    },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "d-flex", attrs: { cols: "6" } },
            [
              _c("v-img", {
                attrs: {
                  role: "img",
                  src: "https://gm.goz.fun/wp-content/uploads/2023/03/review1.jpg",
                  alt: "Review Image 1",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "v-container",
                { staticClass: "pa-0 pl-2", staticStyle: { margin: "-4px 0" } },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { staticClass: "d-flex", attrs: { cols: "7" } },
                        [
                          _c("v-img", {
                            attrs: {
                              role: "img",
                              src: "https://gm.goz.fun/wp-content/uploads/2023/03/review2.png",
                              alt: "Review Image 2",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { staticClass: "d-flex", attrs: { cols: "5" } },
                        [
                          _c("v-img", {
                            attrs: {
                              role: "img",
                              src: "https://gm.goz.fun/wp-content/uploads/2023/03/review3.png",
                              alt: "Review Image 3",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { staticClass: "d-flex", attrs: { cols: "5" } },
                        [
                          _c("v-img", {
                            attrs: {
                              role: "img",
                              src: "https://gm.goz.fun/wp-content/uploads/2023/03/review4.png",
                              alt: "Review Image 4",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { staticClass: "d-flex", attrs: { cols: "7" } },
                        [
                          _c("v-img", {
                            attrs: {
                              role: "img",
                              src: "https://gm.goz.fun/wp-content/uploads/2023/03/review5.png",
                              alt: "Review Image 5",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-title",
        { staticClass: "align-start" },
        [
          _c("div", [
            _c("span", { staticClass: "text-h5" }, [
              _vm._v(_vm._s(_vm.$t("components.reviews.title"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "grey--text font-weight-light" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("components.reviews.category")) +
                  "\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: {
                width: "400",
                role: "dialog",
                "aria-labelledby": "shareDialogTitle",
              },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function (ref) {
                    var on = ref.on
                    return [
                      _c(
                        "v-icon",
                        _vm._g(
                          {
                            attrs: {
                              role: "button",
                              tabindex: "0",
                              "aria-label": "Share Review",
                            },
                            on: {
                              keydown: [
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return $event.target.click()
                                },
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "space",
                                      32,
                                      $event.key,
                                      [" ", "Spacebar"]
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  return $event.target.click()
                                },
                              ],
                            },
                          },
                          on
                        ),
                        [_vm._v("\n          mdi-share-variant\n        ")]
                      ),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.dialog,
                callback: function ($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog",
              },
            },
            [
              _vm._v(" "),
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "text-h6 font-weight-bold",
                          attrs: { id: "shareDialogTitle" },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t("components.reviews.buttons.share")
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "mx-0",
                          attrs: {
                            icon: "",
                            "aria-label": "Close Share Dialog",
                          },
                          on: {
                            click: function ($event) {
                              _vm.dialog = false
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-close-circle-outline")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list",
                    [
                      _c(
                        "v-list-item",
                        {
                          staticClass: "fb-xfbml-parse-ignore",
                          attrs: {
                            "aria-label": _vm.$t(
                              "components.reviews.copy.shareFb"
                            ),
                            role: "link",
                            tabindex: "0",
                            rel: "noopener noreferrer",
                            target: "_blank",
                            href:
                              "https://www.facebook.com/sharer/sharer.php?u=" +
                              _vm.websiteLink +
                              "&src=sdkpreparse",
                          },
                        },
                        [
                          _c(
                            "v-list-item-action",
                            [_c("v-icon", [_vm._v("fab fa-facebook")])],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-card-title", [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t("components.reviews.buttons.facebook")
                                ) +
                                "\n            "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item",
                        {
                          staticClass: "twitter-share-button",
                          attrs: {
                            "aria-label": _vm.$t(
                              "components.reviews.copy.shareTwitter"
                            ),
                            role: "link",
                            tabindex: "0",
                            rel: "noopener noreferrer",
                            target: "_blank",
                            href:
                              "https://twitter.com/intent/tweet?url=" +
                              _vm.websiteLink,
                          },
                        },
                        [
                          _c(
                            "v-list-item-action",
                            [
                              _c("v-icon", { attrs: { color: "cyan" } }, [
                                _vm._v(
                                  "\n                fab fa-twitter\n              "
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-card-title", [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t("components.reviews.buttons.twitter")
                                ) +
                                "\n            "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-text-field", {
                    ref: "link",
                    staticClass: "pa-4",
                    attrs: {
                      label: _vm.$t("components.reviews.copy.shareTitle"),
                      readonly: "",
                      value: _vm.websiteLink,
                      "aria-describedby": "shareInstructions",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.sharableLink(_vm.websiteLink)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "sr-only",
                      attrs: { id: "shareInstructions" },
                    },
                    [
                      _vm._v(
                        "\n          Click to copy the sharable link to clipboard\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c(
        "v-card-actions",
        [
          _c(
            "span",
            {
              staticClass:
                "pl-2 white--text text--darken-2 font-weight-light text-caption",
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("components.reviews.totalReviews")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass:
                "pl-2 white--text text--darken-2 font-weight-light text-caption",
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("components.reviews.exciteUserToReview")) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider", { attrs: { dark: "" } }),
      _vm._v(" "),
      _c(
        "v-card-actions",
        {
          staticClass: "pa-4",
          attrs: { role: "button", tabindex: "0", "aria-label": "Rate Us" },
          on: {
            click: function ($event) {
              return _vm.onRateUs(_vm.fbPage + "reviews")
            },
            keydown: [
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.onRateUs(_vm.fbPage + "reviews")
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "space", 32, $event.key, [
                    " ",
                    "Spacebar",
                  ])
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.onRateUs(_vm.fbPage + "reviews")
              },
            ],
          },
        },
        [
          _vm._v(
            "\n    " + _vm._s(_vm.$t("components.reviews.rate")) + "\n    "
          ),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "grey--text text--lighten-2 text-caption mr-2" },
            [_vm._v("\n      (" + _vm._s(_vm.rating) + ")\n    ")]
          ),
          _vm._v(" "),
          _c("v-rating", {
            attrs: {
              "background-color": "white",
              color: "orange accent-4",
              dense: "",
              "half-increments": "",
              readonly: "",
              hover: "",
              size: "18",
              "aria-hidden": "true",
            },
            model: {
              value: _vm.rating,
              callback: function ($$v) {
                _vm.rating = $$v
              },
              expression: "rating",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }